import template from './user-certificates.html';
import userCertificatesController from './user-certificates.controller';
import './user-certificates.styl';

let userCertificatesComponent = {
  restrict: 'E',
  bindings: {
    certificates: '<'
  },
  template,
  controller: userCertificatesController,
  controllerAs: 'vm'
};

export default userCertificatesComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-certificates/user-certificates.component.js
 **/